import { ErrorHandler, inject, Injectable, Injector } from '@angular/core'

import { LogLevel } from '../log-level.enum'
import { CloudWatchLogger } from './cloud-watch-logger.service'

/**
 * Angular ErrorHandler to send uncaught Errors to AWS CloudWatch Logs
 * requires the {@link CloudWatchLogger}
 */
@Injectable({ providedIn: 'root' })
export class CloudWatchErrorHandler extends ErrorHandler {
  private readonly injector = inject(Injector)

  constructor() {
    super()
  }

  override handleError(error: unknown): void {
    // prevent cyclic dependencies (eg. when CLOUD_WATCH_LOG_TRANSPORT_CONFIG needs config from httpClient request)
    this.injector.get(CloudWatchLogger).logMessage(LogLevel.ERROR, 'BrowserJsException', new Date(), [error])

    // call super.handleError to print error the angular way to the console
    super.handleError(error)
  }
}
